import React from "react";
import "./Unauthorized.css";

const UnAuthorized = () => {
  return (
    <div className="container">
      <div className="message">
        <h2>401</h2>
        <h1>UnAuthorized Access</h1>
        <h3>Why am I seeing this?</h3>
        <p>
          You don’t have permission to access this page. Please log in with the
          correct credentials or contact the administrator for access.
        </p>
        <a href="/">Go To DashBoard</a>
      </div>
    </div>
  );
};

export default UnAuthorized;
